import { render, staticRenderFns } from "./growthValueRule.vue?vue&type=template&id=bb94cfcc&"
import script from "./growthValueRule.vue?vue&type=script&lang=js&"
export * from "./growthValueRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports